import React from "react";

import { Card, CardContent, CardHeader } from "@mui/material";
import { AppSwitch } from "Components/Generic/AppSwitch";
import { useTranslation } from "react-i18next";

import { useStyles } from "./styles";

const barSkeleton = require("Assets/img/overview-config/bar-skeleton.svg");
const cardSkeleton = require("Assets/img/overview-config/card-skeleton.svg");
const doughnutSkeleton = require("Assets/img/overview-config/doughnut-skeleton.svg");
const lineSkeleton = require("Assets/img/overview-config/line-skeleton.svg");
const mapSkeleton = require("Assets/img/overview-config/map-skeleton.svg");
const ratioSkeleton = require("Assets/img/overview-config/ratio-skeleton.svg");
const tableSkeleton = require("Assets/img/overview-config/table-skeleton.svg");

interface Props {
  handleChange: (value: boolean) => void;
  label: string;
  type?: string;
  value: boolean;
}

const ConfigWidget = ({ handleChange, label, type, value }: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const getImgSrc = () => {
    switch (type) {
      case "bar":
        return barSkeleton;

      case "card":
        return cardSkeleton;

      case "doughnut":
        return doughnutSkeleton;

      case "line":
        return lineSkeleton;

      case "bubblemap":
      case "map":
        return mapSkeleton;

      case "ratio":
        return ratioSkeleton;

      case "table":
        return tableSkeleton;

      default:
        return ratioSkeleton;
    }
  };

  return (
    <Card className={classes.card} variant="outlined">
      <CardHeader
        action={
          <AppSwitch
            checked={value}
            onChange={(_: any, checked: boolean) => handleChange(checked)}
          />
        }
        className={classes.header}
        title={translate(label)}
      />
      <CardContent className={classes.content}>
        <img className={classes.skeleton} src={getImgSrc()} />
      </CardContent>
    </Card>
  );
};

export default ConfigWidget;
